/* eslint-disable react/jsx-props-no-spreading */
import React, { SVGProps } from 'react';

const SearchIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="13"
    height="13"
    viewBox="0 0 13 13"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
    data-palette="SearchIcon">
    <path
      d="M9.51809 8.69326L12.0165 11.1911L11.1911 12.0165L8.69326 9.51809C7.76385 10.2631 6.60784 10.6684 5.41667 10.6667C2.51867 10.6667 0.166672 8.31467 0.166672 5.41667C0.166672 2.51867 2.51867 0.166672 5.41667 0.166672C8.31467 0.166672 10.6667 2.51867 10.6667 5.41667C10.6684 6.60784 10.2631 7.76385 9.51809 8.69326ZM8.34792 8.26042C9.08824 7.49911 9.50168 6.47859 9.50001 5.41667C9.50001 3.16034 7.67242 1.33334 5.41667 1.33334C3.16034 1.33334 1.33334 3.16034 1.33334 5.41667C1.33334 7.67242 3.16034 9.50001 5.41667 9.50001C6.47859 9.50168 7.49911 9.08824 8.26042 8.34792L8.34792 8.26042Z"
      fill="var(--secondaryText)"
    />
  </svg>
);

export default SearchIcon;
